import { values } from 'lodash'
import { useLocation } from 'react-router-dom'
import { RoutesEnum } from '../types/RoutesEnum'

const isValidSearchTerm = (path: string, pathTerm: string) =>
  values(RoutesEnum).some(searchDestination => path === `/${searchDestination}/${pathTerm}`)

export const useUrlPathTerm = () => {
  const location = useLocation()
  const pathName = location.pathname.split(`/`)
  const lastPathTerm = pathName[pathName.length - 1]

  return isValidSearchTerm(location.pathname, lastPathTerm) ? lastPathTerm : ''
}
